export const PLATFORM_ALERT_RESOLVED_STATUSES = [
  "Resolved",
  "Auto Resolved",
  "Force Resolved",
];

// The Active/Resolved tabs key off the raw system alertStatus. A force-resolved
// incident keeps alertStatus="active" until the ETL picks it up and flips the
// status to resolved, so it stays under Active in the meantime - this is the
// accepted behavior (no finalStatus/notFinalStatus refinement on the tabs).
export const buildAlertTabStatusFilter = (selectedTab) =>
  selectedTab === "resolved"
    ? { errorStatus: ["resolved"] }
    : { errorStatus: ["active"] };

export const PLATFORM_ALERT_OVERDUE_CONFIG_KEY = 'alerts.PlatformAlertsv2.config.overdueNumDays';

export const csvColumns = [
  { key: "deviceID", dataIndex: "deviceID", headerLabel: "IMEI" },
  { key: "vehicleSubType", dataIndex: "vehicleSubType", headerLabel: "Bus Type" },
  { key: "licensePlateNo", dataIndex: "licensePlateNo", headerLabel: "Bus Number" },
  { key: "customerDBTimeInsert", dataIndex: "customerDBTimeInsert", headerLabel: "Alert Triggered Time" },
  { key: "originDepo", dataIndex: "originDepo", headerLabel: "Depot" },
  { key: "originCity", dataIndex: "originCity", headerLabel: "City" },
  { key: "originState", dataIndex: "originState", headerLabel: "State" },
  { key: "originCountry", dataIndex: "originCountry", headerLabel: "Country" },
  { key: "vin", dataIndex: "vin", headerLabel: "Chassis Number" },
  { key: "incidentID", dataIndex: "incidentID", headerLabel: "Incident ID" },
  { key: "incidentErrorCode", dataIndex: "incidentErrorCode", headerLabel: "Alert Code" },
  { key: "severity", dataIndex: "severity", headerLabel: "Severity" },
  { key: "incidentErrorName", dataIndex: "incidentErrorName", headerLabel: "Alert Description" },
  { key: "bmsAlertStatus", dataIndex: "bmsAlertStatus", headerLabel: "Alert Status" },
  { key: "entityAffected", dataIndex: "entityAffected", headerLabel: "Entity Affected" },
  { key: "entityAffectedID", dataIndex: "entityAffectedID", headerLabel: "Entity Affected ID" },
  { key: "entityAffectedDisplayID", dataIndex: "entityAffectedDisplayID", headerLabel: "Entity Affected Display ID" },
  { key: "category", dataIndex: "category", headerLabel: "Category" },
];

export const csvColumnsForResolved = [
  ...csvColumns,
  { key: "resolveCustomerDBTime", dataIndex: "resolveCustomerDBTime", headerLabel: "Resolved Time" },
  { key: "resolutionTime", dataIndex: "resolutionTime", headerLabel: "Resolution Duration (Minutes)" },
];
